import type { Bilingual } from ".";

// Abandoned-checkout recovery: the seller's dashboard list + the Settings opt-in.
export const cartRecovery: Bilingual = {
  ms: {
    "dash.settings.home.cartRecovery": "Pulih troli tertinggal",
    "dash.settings.home.cartRecoveryHelp":
      "Simpan nama, emel & troli pembeli sebaik sahaja mereka masukkan emel di checkout — walaupun belum bayar. Hubungi mereka semula (WhatsApp) untuk selamatkan jualan.",

    "dash.abandoned.title": "Troli Tertinggal",
    "dash.abandoned.subtitle":
      "Pembeli yang mula checkout tapi belum bayar. Hubungi mereka untuk pulihkan jualan.",
    "dash.abandoned.statOpen": "Belum selesai",
    "dash.abandoned.statRecovered": "Berjaya dipulih",
    "dash.abandoned.statRecoveredValue": "Nilai dipulih",
    "dash.abandoned.col.customer": "Pelanggan",
    "dash.abandoned.col.phone": "Telefon",
    "dash.abandoned.col.cart": "Troli",
    "dash.abandoned.col.lastSeen": "Kali terakhir",
    "dash.abandoned.itemCount": "{count} item",
    "dash.abandoned.recovered": "Dipulih",
    "dash.abandoned.open": "Terbuka",
    "dash.abandoned.recover": "WhatsApp",
    "dash.abandoned.noPhone": "Tiada telefon",
    "dash.abandoned.thereFallback": "sana",
    "dash.abandoned.waMessage":
      "Hai {name}! Checkout anda belum selesai. Sambung & lengkapkan pesanan di sini: {url}",
    "dash.abandoned.empty": "Belum ada troli tertinggal",
    "dash.abandoned.emptyDesc":
      "Bila pembeli mula checkout tapi tak bayar, mereka muncul di sini. Pastikan 'Pulih troli tertinggal' dihidupkan dalam Tetapan.",
    "dash.abandoned.emailSent": "Emel dihantar",

    "checkout.exit.title": "Tunggu sekejap! 🛒",
    "checkout.exit.body": "Pesanan anda belum selesai. Lengkapkan sekarang sebelum ia hilang.",
    "checkout.exit.stay": "Teruskan checkout",
    "checkout.exit.dismiss": "Tutup",
  },
  en: {
    "dash.settings.home.cartRecovery": "Recover abandoned checkouts",
    "dash.settings.home.cartRecoveryHelp":
      "Save the buyer's name, email & cart the moment they enter their email at checkout — even before they pay. Follow up (WhatsApp) to win the sale back.",

    "dash.abandoned.title": "Abandoned carts",
    "dash.abandoned.subtitle":
      "Buyers who started checkout but didn't pay. Reach out to recover the sale.",
    "dash.abandoned.statOpen": "Open",
    "dash.abandoned.statRecovered": "Recovered",
    "dash.abandoned.statRecoveredValue": "Recovered value",
    "dash.abandoned.col.customer": "Customer",
    "dash.abandoned.col.phone": "Phone",
    "dash.abandoned.col.cart": "Cart",
    "dash.abandoned.col.lastSeen": "Last seen",
    "dash.abandoned.itemCount": "{count} item(s)",
    "dash.abandoned.recovered": "Recovered",
    "dash.abandoned.open": "Open",
    "dash.abandoned.recover": "WhatsApp",
    "dash.abandoned.noPhone": "No phone",
    "dash.abandoned.thereFallback": "there",
    "dash.abandoned.waMessage":
      "Hi {name}! Your checkout isn't finished yet. Pick up where you left off here: {url}",
    "dash.abandoned.empty": "No abandoned carts yet",
    "dash.abandoned.emptyDesc":
      "When a buyer starts checkout but doesn't pay, they'll show up here. Make sure 'Recover abandoned checkouts' is enabled in Settings.",
    "dash.abandoned.emailSent": "Email sent",

    "checkout.exit.title": "Wait — don't go yet! 🛒",
    "checkout.exit.body": "Your order isn't finished. Complete it now before you lose it.",
    "checkout.exit.stay": "Continue checkout",
    "checkout.exit.dismiss": "Close",
  },
};
